import { createStore } from "vuex";
import { auth } from "./auth.module";
import { keepSignedIn } from "./keepSignIn.module";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
  plugins: [createPersistedState()],
  state: {
    isLogin: false,
    user: null,
    panel: null,
    panelData: {},
    serverWSData: {}
  },
  getters: {
    getLoginStatus: (state) => {
      return state.isLogin;
    },
    getUser: (state) => {
      return state.user;
    },
    getPanel: (state) => {
      return state.panel;
    },
    getPanelData: (state) => {
      return state.panelData;
    }
  },
  mutations: {
    channgeIsLoginState(state, payload) {
      state.isLogin = payload;
    },
    channgeUserState(state, payload) {
      state.user = payload;
    },
    changePanel(state, payload) {
      state.panel = payload;
    },
    changePanelData(state, payload) {
      state.panelData = payload;
    }
  },
  actions: {
    changLoginStatus(context, payload) {
      context.commit("channgeIsLoginState", payload);
    },
    setUser(context, payload) {
      context.commit("channgeUserState", payload);
    },
    setPanel(context, payload) {
      context.commit("changePanel", payload);
    },
    setPanelData(context, payload) {
      context.commit("changePanelData", payload);
    },
  },
  modules: {
    auth,
    keepSignedIn,
  },
});

export default store;
